import Anchor from "components/Anchor/Anchor";
import React, { FunctionComponent } from "react";
import styles from "./Action.module.scss";
import ActionProps from "./ActionProps.interface";

const Action: FunctionComponent<ActionProps> = (props): JSX.Element => {
    return (
        <Anchor className={styles.button_link} to={props.url}>
            <span className={styles.adjustment}>
                {props.title}
            </span>

            <svg className={styles.button_icon} width="32" height="32" viewBox="0 0 64 64" style={{ fillRule: "evenodd", clipRule: "evenodd", strokeLinecap: "square" }}>
                <g transform="matrix(1.83018,0,0,1.83018,-746.931,-606.703)">
                    <path d="M409.32,349.337L441.886,349.337L431.368,338.819L441.886,349.337L432.076,359.148" style={{ fill: "none", stroke: "#E6CCBB", strokeWidth: "3px" }} />
                </g>
            </svg>
        </Anchor>
    );
};

export default Action;